import React from 'react';
import { useLogOut } from './useLogOut';

export const withLogOut = Page => {
	return function WrappedComponent(props) {
		const { logOut } = useLogOut();
		return <Page {...props} logOut={logOut} />;
	};
};
